module.exports = __webpack_public_path__ + "2d2dba128b56ca9ed6cb720c759ea563.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/rauchverband/R1.jpg
// module id = 367
// module chunks = 0